"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRECONDITION_FAILED = exports.STATUS_INVALID = exports.STATUS_ERROR = void 0;
exports.STATUS_ERROR = 500;
exports.STATUS_INVALID = 401;
exports.PRECONDITION_FAILED = 412;
//# sourceMappingURL=statusCodes.constants.js.map